import register from 'ShopUiBundle/modules/app/registry';

import './style.scss';

// tslint:disable-next-line
register('catalog-filter-row', () => import(/* webpackMode: "lazy" */'./catalog-filter-row'));
